import React, { Component } from "react";
import ReglasAutorizadasTabla from "./ReglasAutorizadasTabla";
import { connect } from "react-redux";
import { getReglasAutorizadasList } from './ReglasAutorizadasAction'
import { withRouter } from 'react-router-dom';

class ReglasAutorizadasContainer extends Component {

    componentDidMount() {
        //console.log("ReglasAutorizadasContainer");
        this.props.dispatch(getReglasAutorizadasList());
    }

    render() {
        return (
            <div>
                <ReglasAutorizadasTabla />
            </div>
        );
    }

}

export default connect()(ReglasAutorizadasContainer);
